import { Link } from "react-router-dom";
import { Disclaimer } from "../components/Disclaimer";
import { PageHeader } from "../components/PageHeader";
import { config } from "../lib/config";
import { positioningPhrase } from "../lib/constants";

export function ValuationUnit() {
  return (
    <>
      <PageHeader
        eyebrow={config.valuationUnitNameAr}
        title={config.combinedUnitNameAr}
        description="تخدم الوحدة البنوك وشركات التمويل وشركات التأمين ومطوري العقار عبر رأي هندسي مستقل مبني على المعاينة والتشخيص وتقدير تكلفة الإصلاح."
      />
      <section className="py-20">
        <div className="container grid gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="space-y-6 text-lg leading-10 text-graphite">
            <p>
              تقوم وحدة تقييم الأصول العقارية بدور طبقة الثقة الفنية بين الجهة
              الطالبة والأصل العقاري، حيث يتم استقبال الطلب، تحديد نطاق العمل،
              تنفيذ المعاينة الميدانية، تحليل الحالة الفنية، ثم إصدار تقارير
              فنية أو تأمينية قابلة للمراجعة.
            </p>
            <p>
              تعتمد الوحدة على الفحص الهندسي، التشخيص الفني، وتوثيق تكلفة
              الإصلاح وفق بيانات سوق محققة، مع إمكانية تقديم دعم لاحق أو إدارة
              أعمال الإصلاح والترميم عن طريق شركة كيان أو شركاء مؤهلين.
            </p>
            <Link className="btn btn-primary" to="/request-evaluation">
              طلب تقييم أصول عقارية
            </Link>
          </div>
          <div className="rounded-lg bg-charcoal p-8 text-white">
            <p className="eyebrow">القيمة المقترحة</p>
            <h2 className="text-3xl font-bold leading-tight">{positioningPhrase}</h2>
            <ul className="mt-6 grid gap-4 text-white/78">
              <li>رأي هندسي مستقل للجهات البنكية والتمويلية والتأمينية.</li>
              <li>معاينة ميدانية وتشخيص فني موثق.</li>
              <li>تقدير تكلفة إصلاح ضمن نطاق عمل محدد.</li>
              <li>إدارة داخلية آمنة للطلبات والمرفقات والتقارير.</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="bg-sand py-12">
        <div className="container">
          <Disclaimer />
        </div>
      </section>
    </>
  );
}
